import {IWidgetControllerConfig} from '@wix/native-components-infra/dist/src/types/types'
import {Dispatch} from 'redux'
import {onInstanceChanged} from '../services/instance'

export const SET_INSTANCE = 'SET_INSTANCE'

const setInstance = (instance: string) => ({
  type: SET_INSTANCE,
  payload: {
    instance,
  },
})

export const watchInstance = (controller: IWidgetControllerConfig, dispatch: Dispatch) =>
  onInstanceChanged(controller, instance => dispatch(setInstance(instance)))
